<div class="antialiased bg-gray-50 h-screen flex flex-col ">
    <app-menu-admin></app-menu-admin>
    <!-- Sidebar -->
    <app-sidebar-admin></app-sidebar-admin>
    <main class="p-4 lg:ml-64 h-auto pt-20">
        <router-outlet></router-outlet>
    </main>
</div>